// extracted by mini-css-extract-plugin
module.exports = {"stage":"styles-module--stage--1E7Y-","stage__image":"styles-module--stage__image--2f-Sl","stage__title":"styles-module--stage__title--LsYXv"};